import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import Footer from '../../../../../components/footer'
import Head from '../../../../../components/head';
import Listar from '../../../../../components/auth/rh/estagiarios/listar'


function ListarEstagiariosScreen() {

    return (
        <Fragment>
            <Head titulo="Listagem de Estagiarios - Recursos Humanos" />
            <HeaderLogged />
            <Container>
               <Listar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListarEstagiariosScreen;